const API_BASE = process.env.REACT_APP_API_BASE || "https://back.varankal.com/api/ai";

async function request(endpoint, method = "GET", data = null) {
  const url = `${API_BASE}${endpoint}`;
  const config = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: 'include' // important to include cookies for auth
  };

  if (data) {
    config.body = JSON.stringify(data);
  }

  const res = await fetch(url, config);
  if (!res.ok) {
    const errData = await res.json().catch(() => ({}));
    throw new Error(errData.message || `API request failed: ${res.status}`);
  }
  return res.json();
}

export default {
  chat: (message) => request("/chat", "POST", { message }),
  compatibility: () => request("/compatibility", "POST"),
  match: (filters) => request("/match", "POST", filters ? { filters } : null),
  profileSummary: (bio) => request("/profile-summary", "POST", { bio }),
  profileQuality: (bio) => request("/profile-quality", "POST", { bio }),

};
